module.exports = __webpack_public_path__ + "img/clip_image128.9e608956.png";